import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { Copy } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import { toastSuccess, toastError } from '../../../../FormComponents/Toasts'
import CampaignScenarios from './TasksParts/CampaignScenarios'
import InfluencerColumns from './TasksParts/InfluencerColumns'
import PasswordPart from './TasksParts/PasswordPart'
import CampaignReport from './TasksParts/CampaignReport'

export default observer(function SharedData() {
  const { campaign } = useContext(CampaignContext)

  const copySharingUrlToClipboard = (staticText = null) => {
    if (!campaign.password) {
      toastError('Please set a password before sharing this link')
      return
    }
    const sharingLink = `${window.location.origin}/advertiser/campaigns/${campaign.sharing_token}`
    const textToCopy = staticText ? `${staticText}\n\n${sharingLink}` : sharingLink
    navigator.clipboard.writeText(textToCopy);
    toastSuccess('Link copied to clipboard')
  }

  const germanText = 'Der Zugriff auf die Kampagneninformationen erfolgt über einen geschützten Link. Bitte stelle sicher, dass die Zugangsdaten ausschließlich berechtigten Personen zugänglich sind und nicht missbräuchlich oder für andere Zwecke verwendet werden. Alle einsehbaren Informationen sind vertraulich zu behandeln. Kommentare, die über diese Funktion eingetragen werden, sind für alle Zugangsberechtigten sichtbar. Wir bitten daher, auf die Eingabe sensibler Daten zu verzichten.'
  const englishText = 'Access to the campaign information is provided via a protected link. Please ensure that the login details are only accessible to authorized individuals and are not misused or used for other purposes. All accessible information must be treated as confidential. Comments entered through this function are visible to all authorized users. We therefore ask you to refrain from entering sensitive data.'
  return (
    <>
      <div className="bg-white dark:bg-rb-dark-mode flex flex-col rounded-lg p-5 pb-2 border-1 border-rb-widget-boarder dark:border-rb-dark-mode-lighter h-72">
        <div className="flex justify-between items-center mb-1 pb-1">
          <p className="font-bold text-xl dark:text-white">Sharing</p>
          <div className="flex gap-2">
            <button
              className="flex items-center bg-rb-green text-white p-2 px-3 rounded-md hover:bg-opacity-90 dark:text-rb-dark-mode"
              onClick={() => copySharingUrlToClipboard(germanText)}
            >
              <Copy className="mr-1"/> DE
            </button>
            <button
              className="flex items-center bg-rb-green text-white p-2 px-3 rounded-md hover:bg-opacity-90 dark:text-rb-dark-mode"
              onClick={() => copySharingUrlToClipboard(englishText)}
            >
              <Copy className="mr-1"/> EN
            </button>
          </div>
        </div>
        <div className="overflow-y-auto" style={{ height: 'calc(100% - 4rem)' }}>
          <PasswordPart />
          <InfluencerColumns />
          <CampaignScenarios />
          <CampaignReport />
        </div>
      </div>
    </>
  )
})